export { default } from './CustomerAvatar'
export type { CustomerAvatarProps } from './CustomerAvatar'
